<template>
  <section>
    <div
      class="container"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <div>
        <HeaderDateil></HeaderDateil>
      </div>
      <div class="zhuti">
        <!-- 所有题目 -->
        <div class="all-questions">
          <!-- 单选题 -->
          <div
            class="dxt-questions"
          >
            <div
              class="questions-answers-box"
              v-for="(item, index) in abc"
              :key="index"
              v-if="item.type == 1"
              @click="btnindex(item, index)"
              v-clickDown
            >
              <!-- 题目和答题区域 -->
              <div class="questions-answers">
                <div class="questions">
                  <!-- 题目展示 -->
                  <div class="subject">
                    <span class="padding-r5">{{ index + 1 }}.</span>
                    <span
                      class="img-size"
                      v-html="item.title"
                      :id="item.id"
                    ></span>
                  </div>
                </div>
                <!-- 选择区域 -->
                <div class="choose">
                  <ul>
                    <li
                      v-for="(items, indexs) in item.answer"
                      :key="indexs"
                      @click="radioChange(index, indexs, item)"
                    >
                      <label :for="item.Id" class="xz-label">
                        <input
                          type="radio"
                          v-model="item.value"
                          :value="items.Id"
                          :id="item.Id"
                          :disabled="item.Status"
                          style="margin-right: 10px"
                        />
                        <span style="text-index: -2em; padding-right: 5px">
                          {{
                            String.fromCharCode(64 + parseInt(indexs + 1))
                          }}.</span
                        >
                        {{ items.Name }}
                      </label>
                    </li>
                  </ul>
                  <div class="answer" v-if="item.Status == true">
                    <div class="correct">
                      <span v-if="!item.answer.some((v) => v.IsCheck == true)"
                        ><i
                          class="el-icon-warning"
                          style="color: #e6a23c; width: 25px; font-size: 18px"
                        ></i
                        >未作答</span
                      >

                      <span v-else>
                        <span
                          v-if="
                            item.answer.some(
                              (v) => v.IsRight == true && v.IsCheck == true
                            )
                          "
                        >
                          <i
                            class="el-icon-success"
                            style="color: #67c23a; width: 25px; font-size: 18px"
                          ></i>
                          答对了
                        </span>
                        <span
                          v-else
                        >
                          <i
                            class="el-icon-error"
                            style="color: #f56c6c; width: 25px; font-size: 18px"
                          ></i>

                          答错了
                        </span>
                      </span>
                    </div>
                    <div
                      v-for="(items, indexs) in item.answer"
                      :key="indexs"
                      :id="items.Name"
                      class="right-key"
                    >
                      <span class="right-keys" v-if="items.IsRight == true"
                        >正确答案：{{
                          String.fromCharCode(64 + parseInt(indexs + 1))
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 多选题 -->
          <div
            class="dxt-questions"
          >
            <!-- 这里说是循环，但实际上只有一个元素会v-show出来 -->
            <div
              class="questions-answers-box"
              v-for="(item, index1) in abc"
              :key="index1"
              v-if="item.type == 2"
              @click="btnindex(item, index1)"
              v-clickDown
            >
              <div class="questions-answers">
                <div class="questions">
                  <div class="subject">
                    <span class="padding-r5">{{ index1 + 1 }}.</span>
                    <span
                      class="img-size"
                      v-html="item.title"
                      :id="item.id"
                    ></span>
                  </div>
                </div>
                <div class="choose">
                  <ul>
                    <li
                      v-for="(items, indexs1) in item.answer"
                      :key="indexs1"
                      :id="items.Name"
                    >
                      <label :for="item.Id" class="xz-label">
                        <input
                          type="checkbox"
                          :disabled="item.Status"
                          v-model="items.IsCheck"
                          :value="items.Id"
                          @change="checkboxChange(index1, indexs1, item)"
                          style="margin-right: 10px"
                          :id="item.Id"
                        />
                        <span style="text-index: -2em; padding-right: 5px">
                          {{
                            String.fromCharCode(64 + parseInt(indexs1 + 1))
                          }}.</span
                        >
                        {{ items.Name }}
                      </label>
                    </li>
                  </ul>
                  <div class="answer" v-if="item.Status == true">
                    <div class="correct">
                      <span v-if="!item.answer.some((v) => v.IsCheck == true)"
                      ><i
                          class="el-icon-warning"
                          style="color: #e6a23c; width: 25px; font-size: 18px"
                      ></i
                      >未作答</span
                      >

                      <span v-else>
                        <span
                            v-if="
                            !item.answer.some(
                              (v) => v.IsRight == false && v.IsCheck == true
                            ) && !item.answer.some(
                              (v) => v.IsRight == true && v.IsCheck == false
                            )
                          "
                        >
                          <i
                              class="el-icon-success"
                              style="color: #67c23a; width: 25px; font-size: 18px"
                          ></i>
                          答对了
                        </span>
                        <span
                            v-else
                        >
                          <i
                              class="el-icon-error"
                              style="color: #f56c6c; width: 25px; font-size: 18px"
                          ></i>
                          答错了
                        </span>
                      </span>
                    </div>
                    <div
                        class="right-key"
                    >
                      正确答案：
                      <span
                          v-for="(items, indexs) in item.answer"
                          :key="indexs" class="right-keys" v-if="items.IsRight == true"
                          style="letter-spacing: 10px"
                      >{{
                          String.fromCharCode(64 + parseInt(indexs + 1))
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 判断题 -->
          <div
            class="dxt-questions"
          >
            <div
              class="questions-answers-box"
              v-for="(item, index2) in abc"
              :key="index2"
              v-if="item.type == 3"
              @click="btnindex(item, index2)"
              v-clickDown
            >
              <div
                class="questions-answers"
              >
                <div class="questions">
                  <div class="subject">
                    <span class="padding-r5">{{ index2 + 1 }}.</span>
                    <span
                      class="img-size"
                      v-html="item.title"
                      :id="item.id"
                    ></span>
                  </div>
                </div>
                <div
                  class="choose"
                  style="padding-left: 35px; line-height: 50px"
                >
                  <label :for="item.Id" class="xz-label">
                    <input
                      :id="item.Id"
                      :name="item.id"
                      type="radio"
                      @change="dui(index2, item)"
                      style="margin-right: 10px"
                    />
                    正确
                  </label>

                  <label class="xz-label" :for="item.Id">
                    <input
                      :id="item.Id"
                      :name="item.id"
                      type="radio"
                      @change="cuo(index2, item)"
                      style="margin-right: 10px"
                    />
                    错误
                  </label>
                  <div class="answer" v-if="item.Status == true">
                    <div class="correct">
<!--                      {{item.answer}}-->
                      <span v-if="item.answer.some((v) => v.IsCheck === null)"
                      ><i
                          class="el-icon-warning"
                          style="color: #e6a23c; width: 25px; font-size: 18px"
                      ></i
                      >未作答</span
                      >

                      <span v-else>
                        <span
                            v-if="
                            item.answer.some(
                              (v) => v.IsRight == v.IsCheck
                            )
                          "
                        >
                          <i
                              class="el-icon-success"
                              style="color: #67c23a; width: 25px; font-size: 18px"
                          ></i>
                          答对了
                        </span>
                        <span
                            v-else
                        >
                          <i
                              class="el-icon-error"
                              style="color: #f56c6c; width: 25px; font-size: 18px"
                          ></i>

                          答错了
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 答题卡 -->
      <div>
        <left
          @btnLeft="btnLfet"
          :class="'leftzj'"
          ref="left"
          :questionList="questionList"
          v-if="questionList"
        ></left>
      </div>
      <div class="tj">
        <div class="paper-progress">
          <span>当前进度</span>
          <div class="speed-box">
            <span class="speed">{{ speedNum }}</span>
            <span>/</span>
            <span class="speed">{{ allSum }}</span>
          </div>
          <el-progress
            style="width: 80px"
            :show-text="false"
            :percentage="paperPercentage"
            :color="customColor"
          ></el-progress>
        </div>
        <div
          class="switch-topics"
          v-show="
            (showConfirm || btnNextQuestion) && QuestionIndex <= abc.length - 1
          "
        >
          <el-button
            style="width: 100px; margin-top: 10px"
            type="primary"
            size="small"
            @click="btnSubmit"
            >查看答案</el-button
          >
          <!-- <el-button
            style="width: 100px;"
            type="primary"
            size="small"
            @click="btnNextQuestion"
            v-show="showNextQuestion && QuestionIndex<abc.length-1"
          >下一题</el-button>
          <el-button
            style="width: 100px;"
            type="primary"
             size="small"
            @click="btnConfirm"
            v-show="showConfirm && QuestionIndex<=abc.length-1"
          >确 认</el-button>
          <el-button
            style="width: 100px;margin-top: 10px;"
            type="primary"
            size="small"
            @click="btnSubmit"
          >提交试卷</el-button> -->
        </div>
      </div>
    </div>
    <el-dialog
      title="交卷中..."
      :show-close="false"
      width="35%"
      :visible.sync="show"
      :close-on-click-modal="false"
    >
      <transition name="fade">
        <div class="progress">
          <div>
            交卷中
            <span id="a" style="display: none">.</span>
            <span id="b" style="display: none">.</span>
            <span id="c" style="display: none">.</span>
          </div>
          <div style="margin-top: 20px">
            <el-progress
              type="circle"
              :color="customColors"
              :percentage="percentage"
            ></el-progress>
          </div>
          <div>
            <span
              v-if="this.percentage <= 25"
              style="font-size: 10px; color: gray"
              >正在提交答案...</span
            >
            <span v-if="percentage <= 25" style="font-size: 10px; color: gray"
              >正在提交答案...</span
            >
            <span
              v-if="percentage < 50 && percentage > 25"
              style="font-size: 10px; color: gray"
              >正在判分中...</span
            >
            <span
              v-if="percentage > 50 && percentage < 75"
              style="font-size: 10px; color: gray"
              >正在出分中...</span
            >
            <span
              v-if="percentage > 75"
              style="padding-left: 10px; font-size: 10px; color: gray"
              >正在改卷，请稍等！</span
            >
          </div>
        </div>
      </transition>
    </el-dialog>
    <el-dialog
      :visible.sync="submitDialogVisible"
      :show-close="false"
      width="30%"
    >
      <span class="title-info">{{ inforText }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submitDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="Submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisible1"
      :close-on-click-modal="false"
      width="400px"
      :show-close="false"
      style="margin-top: 10%"
      center
    >
      <div class="cheat-box">
        <div class="cheat-title">考试成绩</div>
        <div class="cheat-container">
          <div class="cheat-beizhu">
            <span class="cheat-beizhu-weight"
              >{{ allscore.toFixed(2) }} 分</span
            >
          </div>
        </div>
        <div class="cheat-button">
          <el-button type="primary" size="mini" @click="dialogVisible1 = false"
            >查看答案</el-button
          >
        </div>
      </div>
    </el-dialog>
  </section>
</template>

<script>
//屏蔽粘贴
document.onpaste = function (event) {
  if (window.event) {
    event = window.event;
  }
  try {
    var the = event.srcElement;
    if (
      !(
        (the.tagName == "INPUT" && the.type.toLowerCase() == "text") ||
        the.tagName == "TEXTAREA"
      )
    ) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};
//屏蔽复制
document.oncopy = function (event) {
  if (window.event) {
    event = window.event;
  }
  try {
    var the = event.srcElement;
    if (
      !(
        (the.tagName == "INPUT" && the.type.toLowerCase() == "text") ||
        the.tagName == "TEXTAREA"
      )
    ) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};
//屏蔽剪切
document.oncut = function (event) {
  if (window.event) {
    event = window.event;
  }
  try {
    var the = event.srcElement;
    if (
      !(
        (the.tagName == "INPUT" && the.type.toLowerCase() == "text") ||
        the.tagName == "TEXTAREA"
      )
    ) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};
//屏蔽选中
document.onselectstart = function (event) {
  if (window.event) {
    event = window.event;
  }
  try {
    var the = event.srcElement;
    if (
      !(
        (the.tagName == "INPUT" && the.type.toLowerCase() == "text") ||
        the.tagName == "TEXTAREA"
      )
    ) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};
import vHeader from "../../header/index";
import left from "../paper/left";
import {
  SelectPaperQuestion,
  SelectPaperDetail,
  GetDetail,
  EnterPaper,
  SelectQuestion,
} from "../../../api/exam/paper";
import * as pmiDictionary from "@/api/pmi/dictionarys";
import * as pmiDept from "@/api/pmi/dept";
import HeaderDateil from "@/components/headerDateil";
import * as Exam from "@/api/exam/exam";

export default {
  components: {
    vHeader,
    left,
    HeaderDateil,
  },
  data() {
    return {
      //弹框提示信息
      inforText: "",
      //提交弹框的显示和隐藏
      submitDialogVisible: false,
      jindu: "",
      zongjindu: "",
      abc: [],
      dxt: 0,
      dxtSum: 0,
      tkt: 0, //填空题
      tktSum: 0,
      tktInput: null,
      pdt: 0, //判断题
      pdtSum: 0,
      wdt: 0, //问答题
      wdtSum: 0,
      wdtInput: null,
      ddxt: 0, //多选题
      ddxtSum: 0,
      sct: 0,
      sctSum: 0,
      Status: false,
      paperId: localStorage.getItem("paperId"),
      Ids: localStorage.getItem("Id"),
      fix: false,
      PaperDetail: [],
      ExamDetail: [],
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: true,
      date: null,
      ExamStatus: true,
      loading: true, //遮罩层
      percentage: 0, //进度条进度
      customColors: [
        //进度条颜色变化
        { color: "#f56c6c", percentage: 20 },
        { color: "#e6a23c", percentage: 40 },
        { color: "#6f7ad3", percentage: 60 },
        { color: "#1989fa", percentage: 80 },
        { color: "#5cb87a", percentage: 100 },
      ],
      show: false, //vue动画加载
      fullscreen: false, //默认全屏状态
      frequency: 0, //计算退出考试次数
      QuestionIndex: 0, //题目序号
      showQuestion: [], //保存自执行点击事件获取的index
      itemList: [],
      time: null, //考试时间
      interval: null,
      hr: 0,
      mins: 0,
      sec: 0,
      customColor: "#409eff",
      paperPercentage: 0,
      speedNum: 0, //进度
      allSum: 0,
      showConfirm: true, //显示确认按钮
      showNextQuestion: false, //显示下一题按钮
      subjectList: [],
      deptList: [],
      userName: "无",
      deptName: "无",
      urlA: "",
      questionList: null,
      allscore: 0,
    };
  },
  beforeRouteLeave(to, from, next) {
    sessionStorage.removeItem("list");
    localStorage.removeItem("oldtimes");
    next();
  },
  methods: {
    //进入考试页面
    EnterPapershicao(item) {
      let para = {
        examId: this.Ids,
        questionId: item.id,
        userId: this.$store.state.User.ids,
      };
      Exam.getShiCaoUrlNew(para).then((res) => {
        this.urlA = res.result;
        window.location.href = this.urlA;
      });
    },
    //获取所有科目
    getSubjectList() {
      let _this = this;
      let data = { NamespaceId: 6 };
      pmiDictionary.getList(data).then((res) => {
        res.data.forEach(function (item, index) {
          let modeInfo = {};
          modeInfo.value = item.id;
          modeInfo.label = item.name;
          _this.subjectList.push(modeInfo);
        });
      });
    },
    //获取所有部门
    getCateList() {
      let _this = this;
      let para = {
        Page: 1,
        Limit: 100,
      };
      pmiDept.getList(para).then((res) => {
        res.data.forEach(function (item, index) {
          let modeInfo = {};
          modeInfo.value = item.id;
          modeInfo.label = item.name;
          _this.deptList.push(modeInfo);
        });
      });
    },
    //查看解析
    btnAnalysis(index) {
      this.$nextTick(() => {
        this.abc[index].Status = true;
        // 刷新data中的数据
        this.$forceUpdate();
      });
    },
    //接收子级传过来的index
    btnLfet(index) {
      this.QuestionIndex = index;
      if (this.abc[index].Status == true) {
        this.showConfirm = false;
        this.showNextQuestion = true;
      } else {
        this.showConfirm = true;
        this.showNextQuestion = false;
      }
    },
    btnindex(item, index) {
      this.showQuestion.push(index);
    },
    //点击确认
    btnConfirm() {
      this.showConfirm = false;
      this.showNextQuestion = true;
      this.btnAnalysis(this.QuestionIndex);
    },
    //点击下一题
    btnNextQuestion() {
      this.QuestionIndex += 1;
      if (this.abc[this.QuestionIndex].Status == true) {
        this.showConfirm = false;
        this.showNextQuestion = true;
      } else {
        this.showConfirm = true;
        this.showNextQuestion = false;
      }
    },
    //点击提交按钮
    btnSubmit() {
      this.submitDialogVisible = true;
      for (let k = 0; k < this.abc.length; k++) {
        if (this.abc[k].MyCate == true) {
          this.inforText = "是否现在查看答案？";
        } else {
          this.inforText = "有题目未完成，是否现在查看答案？";
        }
      }
    },
    //进度条变化
    Progress() {
      let res = [];
      let res2 = [];
      res = res.concat(
        this.abc.map((c) => {
          if (c.MyCate == true) {
            res2.push(c.Status);
          }
          return c.Status;
        })
      );
      this.zongjindu = res.length;
      this.jindu = res2.length;
    },
    getList() {
      let para = {
        // pagerId: parseInt(this.paperId),
        examId: this.Ids,
      };
      // SelectPaperQuestion(para).then((res) => {
      const res = {};
        res.data = JSON.parse(sessionStorage.getItem("tempExam"));
        res.data.reverse();
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].answer = JSON.parse(res.data[i].answer);
          res.data[i].bjStatus = false;
          res.data[i].MyCate = false;
          res.data[i].value = "";
          res.data[i].CheckAnswer = [];
          if (res.data[i].type == 1) {
            this.dxt += 1;
            this.dxtSum += res.data[i].score;
          } else if (res.data[i].type == 2) {
            this.ddxt += 1;
            this.ddxtSum += res.data[i].score;
          } else if (res.data[i].type == 3) {
            this.pdt += 1;
            this.pdtSum += res.data[i].score;
          } else if (res.data[i].type == 5) {
            this.wdt += 1;
            this.wdtSum += res.data[i].score;
            for (let index = 0; index < res.data[i].answer.length; index++) {
              res.data[i].answer[index].letter = "";
            }
          } else if (res.data[i].type == 4) {
            this.tkt += 1;
            this.tktSum += res.data[i].score;
            for (let index = 0; index < res.data[i].answer.length; index++) {
              res.data[i].answer[index].letter = "";
            }
          } else if (res.data[i].type == 6) {
            this.sct += 1;
            this.sctSum += res.data[i].score;
          }
        }
        //处理随机题目
        sessionStorage.setItem("list", JSON.stringify(res.data));
        sessionStorage.removeItem("tijiao");
        this.abc = res.data;
        this.questionList = JSON.stringify(res.data);
        this.allSum = this.abc.length;
        this.loading = false;
      // });
    },
    radioChange(index, indexs, item) {
      if (item.Status) {
        return;
      }
      this.abc[index].answer.map((v, i) => {
        if (i == indexs) {
          v.IsCheck = true;
          this.abc[index].MyCate = true;
          this.$refs.left.Selected(index, indexs, item);
          this.abc[index].CheckAnswer = {
            QuestionId: item.id,
            Value: indexs + 1,
          };
        } else {
          v.IsCheck = false;
          this.abc[index].MyCate = true;
          this.$refs.left.Selected(index, indexs, item);
          this.abc[index].CheckAnswer = {
            QuestionId: item.id,
            Value: indexs + 1,
          };
        }
      });
      this.Progress();
    },
    checkboxChange(index, indexs, item) {
      if (item.Status) {
        return;
      }
      if (this.abc[index].answer[indexs].IsCheck == true) {
        this.abc[index].MyCate = true;
        this.$refs.left.Selected(index, indexs, item);
        this.abc[index].CheckAnswer.push({
          QuestionId: item.id,
          Value: indexs + 1,
        });
      } else if (this.abc[index].answer[indexs].IsCheck == false) {
        this.abc[index].CheckAnswer.splice(0, 1);
      }
      if (this.abc[index].CheckAnswer.length == 0) {
        this.abc[index].MyCate = false;
        this.$refs.left.Selected(index, indexs, item);
      }
      this.Progress();
    },
    dui(index, item) {
      this.abc[index].answer[0].IsCheck = true;
      this.abc[index].CheckAnswer = { QuestionId: item.id, Value: "true" };
      this.abc[index].MyCate = true;
      this.Progress();
      this.$refs.left.Selected(index, 0, item);
    },
    cuo(index, item) {
      this.abc[index].answer[0].IsCheck = false;
      this.abc[index].CheckAnswer = { QuestionId: item.id, Value: "false" };
      this.abc[index].MyCate = true;
      this.Progress();
      this.$refs.left.Selected(index, 0, item);
    },
    inputChange(index, indexs, item) {
      for (let i = 0; i < this.abc[index].answer.length; i++) {
        if (this.abc[index].answer[i].letter != "") {
          this.abc[index].MyCate = true;
          this.$refs.left.Selected(index, indexs, item);
          break;
        } else if (this.abc[index].answer[i].letter == "") {
          this.abc[index].MyCate = false;
          this.$refs.left.Selected(index, indexs, item);
        }
      }
      this.Progress();
    },
    biaoji(item, index) {
      if (item.bjStatus == 0) {
        item.bjStatus = true;
        this.$refs.left.bj(item, index);
        this.$message({
          type: "success",
          message: "已标记!",
        });
      } else {
        item.bjStatus = false;
        this.$refs.left.bj(item, index);
        this.$message({
          type: "success",
          message: "取消标记!",
        });
      }
    },
    //动画加载
    loadings() {
      let _this = this;
      this.show = true;
      if (this.percentage != 100) {
        let s = setInterval(() => {
          this.percentage += 10;
          if (this.percentage == 100) {
            clearInterval(s);
            setTimeout(() => {}, 1000);
            // this.$message({
            //   type: "success",
            //   message: "提交成功!",
            // });
            this.show = false;
            this.percentage = 0;
            setTimeout(() => {
              this.abc.forEach((question) => {
                question.Status = true;
              });
              this.$forceUpdate();
              let allscore = 0;
              let res = [];
              for (let i = 0; i < this.abc.length; i++) {
                if (this.abc[i].CheckAnswer.length == 0) {
                  this.abc[i].CheckAnswer = { QuestionId: 0, Value: 0 };
                }
                res.push(this.abc[i].CheckAnswer);
              }
              for (let k = 0; k < _this.abc.length; k++) {
                if (_this.abc[k].MyCate == true) {
                  if (_this.abc[k].type == 1) {
                    for (let j = 0; j < _this.abc[k].answer.length; j++) {
                      if (
                        _this.abc[k].answer[j].IsRight == true &&
                        _this.abc[k].answer[j].IsCheck == true
                      ) {
                        _this.abc[k].IsRight = true;
                        allscore += _this.abc[k].score;
                      } else {
                        _this.abc[k].IsRight = false;
                      }
                    }
                  } else if (_this.abc[k].type == 2) {
                    // let count=0
                    let flag = 0;
                    for (let j = 0; j < _this.abc[k].answer.length; j++) {
                      if (
                        !(
                          _this.abc[k].answer[j].IsRight ==
                          _this.abc[k].answer[j].IsCheck
                        )
                      ) {
                        flag++; //答错的选项个数
                      }
                    }
                    if (flag > 0) {
                      //如果错误答案数量》0,就不加分,否则加分
                      _this.abc[k].IsRight = false;
                      allscore += 0;
                    } else {
                      _this.abc[k].IsRight = true;
                      allscore += _this.abc[k].score;
                    }
                  } else if (this.abc[k].type == 3) {
                    for (let j = 0; j < this.abc[k].answer.length; j++) {
                      if (
                        this.abc[k].answer[j].IsRight ==
                        this.abc[k].answer[j].IsCheck
                      ) {
                        this.abc[k].IsRight = true;
                        allscore += this.abc[k].score;
                      } else {
                        this.abc[k].IsRight = false;
                      }
                    }
                  } else if (this.abc[k].type == 4) {
                    let answerLegth = this.abc[k].answer.length;
                    let newAnswer;
                    for (let j = 0; j < answerLegth; j++) {
                      let Ids = this.abc[k].answer.map((item) => item.letter);
                      let arr = new Array();
                      this.abc[k].answer.forEach((item, index) => {
                        if (!Ids.includes(item.Name)) {
                          arr.push(item);
                        }
                      }); //去掉填写正确的
                      newAnswer = arr.length; //剩下的都是填写错误的
                    }
                    if (newAnswer == answerLegth) {
                      this.abc[k].IsRight = false;
                      allscore += 0;
                    } else if (newAnswer > 0) {
                      allscore +=
                        this.abc[k].score *
                        ((answerLegth - newAnswer) / answerLegth);
                      this.abc[k].IsRight = false;
                    } else if (newAnswer == 0) {
                      allscore += this.abc[k].score;
                      this.abc[k].IsRight = true;
                    }
                  }
                } else {
                  allscore += 0;
                }
              }
              this.allscore = allscore;
              this.submitDialogVisible = false;
              // this.$router.push({
              //   path: "/paperDetail",
              //   query: {
              //     score: allscore,
              //     userName: this.user.name,
              //   },
              // });
            }, 1000);
          }
        }, 50);
      }
    },
    //主动提交
    Submit() {
      this.loadings();
      this.submitDialogVisible = false;
    },
    //禁止滚动
    stop() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    //取消滑动限制
    move() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    //全屏
    screen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    //粘贴无操作
    handlePaste() {
      //粘贴会触发来到这里,无操作就行
    },
    //查询试卷信息
    getpaper() {
      let para = {
        id: this.paperId,
      };
      SelectPaperDetail(para).then((res) => {
        this.PaperDetail = res.result;
      });
    },
    //查询考试信息
    getexam() {
      let para = {
        id: this.Ids,
      };
      GetDetail(para).then((res) => {
        this.ExamDetail = res.result;
        // this.paperTime()
      });
    },
    //进入考试页面
    EnterPaper() {
      this.dialogVisible3 = false;
      //this.screen();
      let para = {
        examId: this.paperId,
        createUserId: this.user.id,
      };
      EnterPaper(para).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "请开始作答",
            type: "success",
          });
        } else {
          this.$message.error("服务器故障，请稍后重试");
        }
      });
    },
  },
  created() {
    if (this.$store.state.User.tokens) {
      this.userName = JSON.parse(this.$store.state.User.infos).name;
      this.deptName = JSON.parse(this.$store.state.User.infos).deptName;
      this.user = this.$store.state.User.ids; //获取用户个人信息
      // this.getCateList();
    }
    //左悬浮div吸顶
    window.onscroll = () => {
      var scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      if (scrollTop >= 418) {
        this.fix = true;
      } else if (scrollTop < 418) {
        this.fix = false;
      }
    };
    // this.getexam();
    this.getList();
    // const data = JSON.parse(sessionStorage.getItem("tempExam"));
    // console.log("tempExam", data);
  },
  //自执行点击事件
  directives: {
    clickDown: {
      inserted(el, binging) {
        el.click();
      },
    },
  },
  mounted() {},
  watch: {
    dialogVisible: {
      handler() {
        if (this.dialogVisible == false) {
          clearInterval(this.timer);
        }
      },
    },
    abc: {
      // 深度监听
      handler(val, oldVal) {
        let myCateList = 0;
        this.abc.forEach((item) => {
          if (item.MyCate) {
            myCateList++;
          }
        });
        this.speedNum = myCateList;
        this.paperPercentage = parseInt(100 * (this.speedNum / this.allSum));
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}
.zhuti {
  width: 50%;
  background-color: white;
  margin-top: 20px;
  margin-left: 30%;
}
.all-questions{
  height: 75vh;
  overflow: auto;
}
.title {
  width: 100%;
  height: 40px;
  padding-top: 15px;
  font-size: 18px;
  background-color: #fafafa;
  border-left: 1px dashed rgb(226, 223, 223);
  border-right: 1px dashed rgb(226, 223, 223);
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-top: 1px dashed rgb(226, 223, 223);
}
li {
  list-style: none;
  font-size: 30px;
  /* padding-bottom: 15px; */
}
.leftzj {
  position: absolute;
  left: 12%;
  top: 180px;
  overflow-y: auto;
  height: 75vh;
  overflow-x: hidden;
}
.tj {
  position: fixed;
  right: 150px;
  top: 180px;
  border-radius: 5px;
  border: 1px solid rgb(226, 223, 223);
}
.paper-time {
  position: fixed;
  right: 100px;
  bottom: 480px;
  width: 120px;
  height: 50px;
  font-size: 14px;
  line-height: 25px;
  font-weight: 400;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  text-align: center;
  padding: 10px 0;
}
.red-color {
  color: red;
  font-size: 18px;
}
.fixed {
  position: fixed;
  left: 12%;
  top: 10px;
  overflow-y: auto;
  height: 75vh;
  overflow-x: hidden;
}
.icon {
  width: 1em;
  height: 1em;
  font-size: 20px;
}
.icons {
  width: 1em;
  height: 1em;
  font-size: 15px;
}
.bj {
  background-color: #1a8cfe;
}
.questions {
  display: flex;
  flex-direction: column;
  /* width: 50%; */
  /* height: 100%; */
  /* min-height: 700px; */
  justify-content: space-between;
  align-items: baseline;
  margin-right: 20px;
  /* border: 1px solid #f2f2f2; */
  border-radius: 5px;
  overflow: auto;
}
.choose {
  /* width: 50%; */
  /* height: 100%; */
  /* min-height: 700px; */
  /* border: 1px solid #f2f2f2; */
  border-radius: 5px;
  padding-top: 20px;
  padding-left: 10px;
  padding-right: 10px;
}
.questions-answers {
  /* border: 1px solid rgb(226, 223, 223); */
  margin-top: 20px;
  margin-bottom: 20px;
}
.answer {
  display: flex;
  flex-direction: column;
  width: 92%;
  border-top: 1px dashed rgb(226, 223, 223);
}
.analysis {
  width: 92%;
  border-top: 1px dashed rgb(226, 223, 223);
  line-height: 40px;
}
.mychange {
  display: flex;
  width: 150px;
  margin-top: 10px;
}
.rightanswer {
  display: flex;
  width: 150px;
  margin-top: 10px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.progress {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 350px;
  /* border: 1px solid rgb(226, 223, 223); */
  border-radius: 5px;
  background-color: #fafafa;
}
.subject {
  display: flex;
  align-items: baseline;
  margin-left: 10px;
}
.padding-r5 {
  padding-right: 5px;
  font-size: 16px;
}
.subject img {
  width: 300px;
  height: 300px;
}
.xz-label {
  font-size: 15px;
  display: flex;
  padding: 7px 0;
  width: 100%;
  align-items: baseline;
}
.xz-label:hover {
  background-color: whitesmoke;
}
.switch-topics {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* border: 1px solid gainsboro; */
  font-size: 14px;
  /* height: 45px; */
  width: 120px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.biaoji-container {
  width: 100%;
  height: 40px;
  display: none;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
}
.biaoji-container .icon-analysis {
  width: 82px;
}
.no-answer {
  margin-top: 10px;
}
.facility-value {
  margin-top: 10px;
  color: blue;
}
.select-keys {
  margin-top: 10px;
}
.tx-keys {
  margin-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid gainsboro;
}
img {
  max-width: 98%;
  max-height: 98%;
}
.img-size {
  max-width: 95%;
  /* width: 280px; */
}
@media (max-width: 1366px) {
  .leftzj {
    position: absolute;
    left: 9%;
    top: 180px;
    overflow-y: auto;
    height: 75vh;
    overflow-x: hidden;
  }
  .fixed {
    position: fixed;
    left: 9%;
    top: 20px;
    overflow-y: auto;
    height: 75vh;
    overflow-x: hidden;
  }
}
@media (max-width: 1680px) {
  .leftzj {
    position: absolute;
    left: 10%;
    top: 180px;
    overflow-y: auto;
    height: 75vh;
    overflow-x: hidden;
  }
  .fixed {
    position: fixed;
    left: 10%;
    top: 20px;
    overflow-y: auto;
    height: 75vh;
    overflow-x: hidden;
  }
}
.title-info {
  display: flex;
  margin-top: 10px;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
}

.goscExam {
  margin: 10px 20px;
  display: flex;
  flex-direction: column;
  line-height: 40px;
  align-items: center;
}
.rules-box {
  display: flex;
  margin-top: 10px;
}
.rules-text {
  /* padding-left: 30px; */
  white-space: nowrap;
}
.paper-progress {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 30px;
  height: 80px;
  border-bottom: 1px solid rgb(226, 223, 223);
  padding: 10px 0;
}
.speed {
  padding: 0 5px;
}

.cheat-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .cheat-title {
    padding: 10px 0;
    font-size: 18px;
    font-weight: 700;
    border-bottom: 1px solid #80808029;
    width: 100%;
    text-align: center;
  }
  .cheat-container {
    height: 120px;
    width: 100%;
    border-bottom: 1px solid #80808029;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .cheat-num {
      width: 80px;
      height: 80px;
      border: 2px solid #808080bf;
      border-radius: 50%;
      text-align: center;
      line-height: 80px;
      font-weight: 700;
      color: #808080bf;
      font-size: 20px;
      margin-bottom: 40px;
    }
    .cheat-beizhu-weight {
      font-weight: 700;
      font-size: 30px;
    }
  }
  .cheat-button {
    margin-top: 20px;
  }
}
</style>